import type { TUtils } from "@monta/utils";
import type { IHeaderBanner, IMenu } from "../constants";
import HeaderBanner from "../HeaderBanner";
import styles from "./header.module.scss";
import HeaderDesktop from "./items/HeaderDesktop";
import HeaderMobile from "./items/HeaderMobile";

export interface HeaderProps {
  menuItems: IMenu[];
  headerBanner?: IHeaderBanner;
  auth: TUtils["auth"];
  api: TUtils["api"];
  cart: TUtils["cart"];
  route: string;
}

const Header = (props: HeaderProps) => {
  const { menuItems, headerBanner, auth, api, cart, route } = props;

  return (
    <>
      <div id="header-portal" />
      <header className={styles["header"]}>
        {headerBanner && <HeaderBanner headerBanner={headerBanner} />}
        <div className={styles["header__desktop"]}>
          <HeaderDesktop menuItems={menuItems} auth={auth} cart={cart} />
        </div>
        <div className={styles["header__mobile"]}>
          <HeaderMobile
            route={route}
            menuItems={menuItems}
            auth={auth}
            api={api}
            cart={cart}
          />
        </div>
      </header>
    </>
  );
};

export default Header;
